import axiosIns from '@/plugins/axios'

export default {
  tracking(id, data = {}) {
    return axiosIns.post(`/v2/inventory/vendible_tags/${id}/tracking`, data)
  },
}
